import React from 'react';
import _ from 'lodash';
import { Table, Loader, Pagination, Button, Menu, Segment, Header } from 'semantic-ui-react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import { getSKPD, getOPD } from '../../../../../_utils/localstorage';
import printJS from 'print-js';
import { messageGagal } from '../../../../../_utils/message';
import ModalEdit from './ModalEdit';
import ModalDetail from './ModalDetail';
import ModalAdd from './ModalAdd';
import swal from 'sweetalert'


export default class ListKuasa extends React.Component {
   constructor(props){
      super(props);
      this.state = {
         column: null,
         data: [],
         result: [],
         result_search:[],
         direction: null,
         requests:true,
         query:"",

         activePage:1,
         totalPages:0,
         itemPerPage:10,
         page:1,
         startfrom:0,

         is_edit:false,
         data_edit:null,
         loading_edit:false,

         is_detail:false,
         data_detail:null,
         loading_detail:false,

         is_add:false,
         pageActive: 1,
      }

      this.printDocument = this.printDocument.bind(this);
      this.onCloseEdit = this.onCloseEdit.bind(this);
      this.onOpenEdit = this.onOpenEdit.bind(this);
      this.onCloseDetail = this.onCloseDetail.bind(this);
      this.onDelete = this.onDelete.bind(this);
      this.onCloseAdd  = this.onCloseAdd.bind(this);
      this.onOpenAdd = this.onOpenAdd.bind(this);
      
   }


   onOpenEdit = (e, { index }) => {
      const { data } = this.state
      this.setState({loading_edit:true})
      setTimeout(()=>{
         this.setState({
            is_edit:true,
            data_edit:data[index],
            loading_edit:false
         });
      }, 400)
   }

   onCloseEdit = () => {
      this.setState({
         is_edit:false,
         data_edit:null
      });
   }

   onOpenAdd = () => {
      setTimeout(()=>{
         this.setState({
            is_add:true,
         });
      }, 100)
   }

   onCloseDetail = () => {
      this.setState({
         is_detail:false,
         data_detail:null
      });
   }

   onDelete = (e, { index }) => {
      swal({
         title: "Apakah anda yakin?",
         text: "Data Pejabat ini akan dihapus atau nonaktif!",
         icon: "warning",
         buttons: true,
         dangerMode: true,
      })
      .then((verif) => {
         if (verif) {
            this.setState({ loading: true });
            fetch(`${BaseURLDev}/kuasa/${this.state.data[index].id}`,{
               method: 'DELETE',
               headers,
            })
            .then(response => {
               if (!response.ok) { 
                  swal("", "Delete data gagal", "error");
                  this.setState({loading: false});
                  return Promise.reject(response.statusText);
                  }
               else{
                  swal("Delete data selesai",{icon:'success'})
                  .then(()=>{
                     this.getData();
                     this.setState({
                        loading: false
                     });
                  });
               }
            })
         }
         else return false
      })
   }

   onCloseAdd = () => {
      this.setState({
         is_add:false,
      });
   }
   
   printDocument() {
      printJS({
         printable:'data_print', 
         type:'html', 
         showModal:true
      })
   }

   getData(){
      fetch(`${BaseURLDev}/kuasa?opt=fetch`, { headers })
      .then(response => {
         if(!response.ok){
            messageGagal("Load data gagal")            
            this.setState({data:[],requests:false});
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         const startfrom = (this.state.page-1)*this.state.itemPerPage
        
         this.setState({
            totalPages:Math.ceil(resJSON.data.length/this.state.itemPerPage),
            data:resJSON.data,
            result:resJSON.data.slice(startfrom,startfrom+this.state.itemPerPage),
            requests:false,
            startfrom:startfrom
         })
      })
      // .catch(err => messageGlobal({
      //    message:"Load data gagal",
      //    option:{refresh:true},
      //    value:"/c/org"
      // }))
   }

   componentWillMount(){
     this.getData()
   }

   handleSort = clickedColumn => () => {
      const { column, result, direction } = this.state

      if (column !== clickedColumn) {
         this.setState({
            column: clickedColumn,
            result: _.sortBy(result, [clickedColumn]),
            direction: 'ascending',
         })

         return
      }

      this.setState({
         result: result.reverse(),
         direction: direction === 'ascending' ? 'descending' : 'ascending',
      })
   }
   
   handlePaginationChange = (e, { activePage }) => {
      if (this.state.pageActive === activePage){
         return false;
      }
      this.setState({ activePage, pageActive: activePage, requests: true })
      if(this.state.query===""){
         const startfrom = (activePage-1)*this.state.itemPerPage
         this.setState({
            startfrom:startfrom,
            result:this.state.data.slice(startfrom,startfrom+this.state.itemPerPage),
            requests:false
         })
      }else{
         const startfrom = (activePage-1)*this.state.itemPerPage
         this.setState({
            startfrom:startfrom,
            result:this.state.result_search.slice(startfrom,startfrom+this.state.itemPerPage),
            requests:false
         })
      }
    
   }

   searchData(e){
      const query = (e.target.value).toLowerCase()
      const { data } = this.state
      this.setState({query:query,requests:true});      
      if(query.length>0){
         var results = [];
         for(let i=0; i<data.length; i++) {
            for(let key in data[i]) {
               if(data[i][key].toLowerCase().indexOf(query)!==-1) {
                  results.push(data[i]);
               }
            }
         }
         // this.setState({ activePage })
         const startfrom = (this.state.page-1)*this.state.itemPerPage
         this.setState({
            totalPages:Math.ceil(results.length/this.state.itemPerPage),
            // data:resJSON.data,
            result_search:results,
            result:results.slice(startfrom,startfrom+this.state.itemPerPage),
            requests:false,
            startfrom:startfrom
         })
         // this.setState({result:results, requests:false});      
      }else{
         const startfrom = (this.state.page-1)*this.state.itemPerPage
         this.setState({
            totalPages:Math.ceil(data.length/this.state.itemPerPage),
            // data:resJSON.data,
            result:data.slice(startfrom,startfrom+this.state.itemPerPage),
            requests:false,
            startfrom:startfrom
         })

         // this.setState({result:this.state.data, requests:false});      
      }
   }

   render() {
      const { requests, column, data, direction } = this.state;

      return (
         <div>
            <Segment>
            {requests ? <Loader active inline='centered' /> :
               <div>
                     <Menu>
                        <Menu.Item>
                           <Button
                              color='green'
                              disabled={requests}
                              content='Tambah data'
                              onClick={()=>this.onOpenAdd()}
                           />
                        </Menu.Item>
                        <Menu.Item>
                           <Header>Kuasa Pengguna Anggaran</Header>
                        </Menu.Item>
                        {/*<Menu.Item position="right">
                           <Input type="text"
                              icon="search"
                              placeholder="Pencarian..."
                              autoFocus 
                              value={this.state.query}
                              style={{width:'300px'}}
                              onChange={this.searchData.bind(this)} />
                        </Menu.Item>*/}
                  </Menu>
                  <div id="data_print">
                  <Table sortable size='small' celled>
                     <Table.Header>
                     <Table.Row>
                        
                        <Table.HeaderCell>#</Table.HeaderCell>
                        <Table.HeaderCell>NIP</Table.HeaderCell>
                        <Table.HeaderCell>Contact</Table.HeaderCell>
                        <Table.HeaderCell sorted={column === 'nama' ? direction : null} onClick={this.handleSort('nama')}>
                           Nama
                        </Table.HeaderCell>
                        <Table.HeaderCell sorted={column === 'jabatan' ? direction : null} onClick={this.handleSort('jabatan')}>
                           Jabatan
                        </Table.HeaderCell>
                        <Table.HeaderCell>Alamat</Table.HeaderCell>
                        <Table.HeaderCell>OPD</Table.HeaderCell>
                        <Table.HeaderCell>SKPD</Table.HeaderCell>
                     </Table.Row>
                     </Table.Header>
                     <Table.Body>
                     {data.map((item, i) => (
                        
                        <Table.Row key={i}>
                           <Table.Cell>
                              <Button.Group size='mini'>
                                 <Button color='red' 
                                    icon='trash' 
                                    index={i}                                          
                                    onClick={this.onDelete} 
                                 />
                                 <Button color='green' 
                                    icon='pencil' 
                                    index={i}                                          
                                    onClick={this.onOpenEdit}   
                                 />
                                 
                              </Button.Group>                                      
                           </Table.Cell>
                           <Table.Cell>{item.kode}</Table.Cell>
                           <Table.Cell>{item.contact}</Table.Cell>
                           <Table.Cell>{item.nama}</Table.Cell>
                           <Table.Cell>{item.jabatan}</Table.Cell>
                           <Table.Cell>{item.alamat}</Table.Cell>
                           
                           <Table.Cell>
                              {getOPD(`${item.kd_urusan}.${item.kd_bidang}.${item.kd_unit}.${item.kd_sub}`)}
                              {/*<b>{item.kd_urusan}.{item.kd_bidang}.{item.kd_unit}.{item.kd_sub}</b>*/}
                           </Table.Cell>

                           <Table.Cell>
                              {getSKPD(`${item.kd_urusan}.${item.kd_bidang}.${item.kd_unit}`)}
                              {/*<b>{item.kd_urusan}.{item.kd_bidang}.{item.kd_unit}.{item.kd_sub}</b>*/}
                           </Table.Cell>
                        </Table.Row>
                     ))}
                     </Table.Body>
                     <Table.Footer fullWidth>
                        <Table.Row>
                           <Table.HeaderCell colSpan='8'>
                              <Pagination activePage={this.state.activePage} 
                                 onPageChange={this.handlePaginationChange} 
                                 totalPages={this.state.totalPages}
                              />
                           </Table.HeaderCell>
                        </Table.Row>
                     </Table.Footer>
                  </Table>

                  {this.state.is_edit && 
                     <ModalEdit 
                        open={this.state.is_edit}
                        data={this.state.data_edit} 
                        onClose={this.onCloseEdit} />
                  }
                  {this.state.is_detail && 
                     <ModalDetail 
                        open={this.state.is_detail}
                        data={this.state.data_detail} 
                        onClose={this.onCloseDetail} />
                  }
                  {this.state.is_add && 
                     <ModalAdd 
                        open={this.state.is_add}
                        // data={this.state.data_edit} 
                        onClose={this.onCloseAdd} />
                  }

                  </div>
               </div>
            }
            </Segment>
         </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_kuasa/ListKuasa.js